import { ConfigReportComboApi } from "go-report-combo/User/services/types";

export const REPORT_kpi_product = {
	id: "REPORT_kpi_product",
	name: "Produkty",
	data: [
		{
			id: "TRANSACTION",
			resource: "TRANSACTION",
			filter: "status|e=PAYMENT_DUE¥PAIDçname|e=ADDON_PHONE_CENTRAL¥DRIVERS¥EMENU¥GOCRM¥GOHUB¥GOORDER¥GOPOS_KDS¥GOPOS_KIOSK¥GOPOS_NUMBER_DISPLAY¥GOSTOCK_IMPORT¥GOSTOCK_INVENTORY_APP¥GOSTOCK_TRANSFER¥GOSTOCK_PLAN",
			groups: ["NONE", "NAME"],
			columns: [
				{
					id: "summary",
					filter: "date|bt=previous_2-2_months",
				},
			],
		},
		{
			id: "TRANSACTION_LAST_MONTH",
			resource: "TRANSACTION",
			filter: "status|e=PAYMENT_DUE¥PAIDçname|e=ADDON_PHONE_CENTRAL¥DRIVERS¥EMENU¥GOCRM¥GOHUB¥GOORDER¥GOPOS_KDS¥GOPOS_KIOSK¥GOPOS_NUMBER_DISPLAY¥GOSTOCK_IMPORT¥GOSTOCK_INVENTORY_APP¥GOSTOCK_TRANSFER¥GOSTOCK_PLAN",
			groups: ["NONE", "NAME"],
			columns: [
				{
					id: "summary",
					filter: "date|bt=previous_3-3_months",
				},
			],
		},
		{
			id: "TRANSACTION_LAST_YEAR",
			resource: "TRANSACTION",
			filter: "status|e=PAYMENT_DUE¥PAIDçname|e=ADDON_PHONE_CENTRAL¥DRIVERS¥EMENU¥GOCRM¥GOHUB¥GOORDER¥GOPOS_KDS¥GOPOS_KIOSK¥GOPOS_NUMBER_DISPLAY¥GOSTOCK_IMPORT¥GOSTOCK_INVENTORY_APP¥GOSTOCK_TRANSFER¥GOSTOCK_PLAN",
			groups: ["NONE", "NAME"],
			columns: [
				{
					id: "summary",
					filter: "date|bt=previous_13-13_months",
				},
			],
		},
	],
	rows: [
		{
			id: "SUMMARY_organization_product",
			name: "Produkty",
			type: "CALCULATE",
			aggregate: "TRANSACTION.solution_quantity",
			group: "COMPANY_SOURCE",
			aggregate_columns: {
				current_location: "TRANSACTION.solution_quantity",
				last_month_location: "TRANSACTION_LAST_MONTH.solution_quantity",
				last_month_location_growth:
					"((TRANSACTION.solution_quantity - TRANSACTION_LAST_MONTH.solution_quantity) / TRANSACTION_LAST_MONTH.solution_quantity) * 100",
				last_year_location: "TRANSACTION_LAST_YEAR.solution_quantity",
				last_year_location_growth:
					"((TRANSACTION.solution_quantity - TRANSACTION_LAST_YEAR.solution_quantity) / TRANSACTION_LAST_YEAR.solution_quantity) * 100",
			},
		},
	],
	columns: [
		{
			id: "current_location",
			data_column_id: "summary",
			name: "Ilość",
		},
		{
			id: "last_month_location",
			data_column_id: "summary",
			name: "Poprzedni miesiąc",
		},
		{
			id: "last_month_location_growth",
			data_column_id: "summary",
			name: "Wzrost %",
			format: "PERCENT",
		},
		{
			id: "last_year_location",
			data_column_id: "summary",
			name: "Poprzedni rok",
		},
		{
			id: "last_year_location_growth",
			data_column_id: "summary",
			name: "Wzrost %",
			format: "PERCENT",
		},
	],
} as ConfigReportComboApi;
